import { render, staticRenderFns } from "./AssignedBook.vue?vue&type=template&id=6b686bd1&scoped=true"
import script from "./AssignedBook.vue?vue&type=script&lang=js"
export * from "./AssignedBook.vue?vue&type=script&lang=js"
import style0 from "./AssignedBook.vue?vue&type=style&index=0&id=6b686bd1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b686bd1",
  null
  
)

export default component.exports